import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    menuPaper: {
      width: 450,
      maxHeight: 400,
      marginTop: theme.spacing(0.5),
    },
    itemLabel: {
      fontSize: theme.typography.pxToRem(14),
    },
  }),
  { name: 'ContextMenuGenerationTool' }
);
